import React, { useContext, useEffect, useRef, useState } from "react";
import SavedProductContext from "../SavedProductsContext";
import { lookupByBarcode } from "../services/ProductsService";
import { AddProductModalForm } from "./AddProductModalForm";
import { updateSavedProducts } from "../utils/SavedProductsLocal";

import {
  Box,
  Button,
  HStack,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure
} from "@chakra-ui/react";

export const SearchProductInput = () => {
  const barcodeInputRef = useRef(null);
  const [query, setQuery] = useState("");
  const [modalContent, setModalContent] = useState({
    form: false,
    title: "",
    body: "",
    productBarcode: "",
  });
  const [products, setProducts, productsQty, setProductsQty] = useContext(
    SavedProductContext
  );
  const { isOpen, onOpen, onClose } = useDisclosure();

  const getProducts = async () => {
    if (query != null && query !== "") {
      const product = await lookupByBarcode(query);
      const productData = product.data;

      if (product.data["msg"] !== "success") {
        // Handle unsuccessful search
        if (product.data["msg"] === "not_found") {
          setModalContent({
            title: "Producto no encontrado",
            body: "Agregar producto",
            form: true,
          });
          console.log(query);
        } else {
          setModalContent({
            title: "Error inesperado",
            body: product.data["msg"],
            form: false,
          });
        }
        onOpen();
      } else {
        setProducts({ ...products, [productData.id]: productData });
        setProductsQty({
          ...productsQty,
          [productData.id]: productsQty[productData.id]
            ? productsQty[productData.id] + 1
            : 1,
        });
        updateSavedProducts(productData);
        setQuery("");
      }
    } else {
    }
  };

  const handleEnter = (event) => {
    if (event.key === "Enter") {
      getProducts();
    }
  };

  const handleSubmit = () => {
    getProducts();
  };

  useEffect(() => {
    barcodeInputRef.current.focus();
  }, []);

  return (
    <>
      <Box>
        <HStack>
          <Input
            placeholder="Código o nombre del producto"
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={handleEnter}
            ref={barcodeInputRef}
            value={query}
          />
          <Button onClick={handleSubmit}>Buscar</Button>
        </HStack>
      </Box>
      {/*  Modal */}
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />

        <ModalContent>
          <ModalHeader>{modalContent.title}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {modalContent.form ? (
              <AddProductModalForm productBarcode={query} />
            ) : (
              modalContent.body
            )}
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Cerrar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
